import dayjs from 'dayjs';

/**
 * 日時フォーマット
 * @param dateISOstring
 * @param template
 * templateに応じてフォーマット方法を切り替える
 */
export const datetimeFormat = (dateISOstring: string, template?: 'datetime' | string) => {
  const d = dayjs(dateISOstring);
  switch (template) {
    case undefined:
    case 'datetime':
      return d.format('YYYY/MM/DD HH:mm');
    case 'date':
      return d.format('YYYY/MM/DD');
    default:
      return d.format(template);
  }
};

/**
 * Object.fromEntriesのpolyfill
 * @param iterable
 */
export function objectFromEntries(iterable: any[][]) {
  return [...iterable].reduce<Record<string, any>>((obj, [key, val]) => {
    obj[key as string] = val;
    return obj;
  }, {});
}
